import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, PlayCircle, Share2, BarChart3, RefreshCw } from 'lucide-react';
interface SlideWhatSnakkerDoesProps {
  onContinue: () => void;
}
export function SlideWhatSnakkerDoes({
  onContinue
}: SlideWhatSnakkerDoesProps) {
  const [stage, setStage] = useState(0);
  const steps = [{
    icon: <FileText className="w-5 h-5" data-id="element-596" />,
    label: 'Creates campaigns from existing approved content'
  }, {
    icon: <PlayCircle className="w-5 h-5" data-id="element-597" />,
    label: <>
          Turns them into short interactive Snaks
          <sup className="text-xs" data-id="element-598">™</sup>
        </>
  }, {
    icon: <Share2 className="w-5 h-5" data-id="element-599" />,
    label: 'Publishes across channels'
  }, {
    icon: <BarChart3 className="w-5 h-5" data-id="element-600" />,
    label: 'Captures behavioral data'
  }, {
    icon: <RefreshCw className="w-5 h-5" data-id="element-601" />,
    label: 'Improves campaign after campaign'
  }];
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 400);
    const t2 = setTimeout(() => setStage(2), 1000);
    const timers = steps.map((_, idx) => setTimeout(() => setStage(3 + idx), 1500 + idx * 350));
    const finalTimer = setTimeout(() => setStage(3 + steps.length), 1500 + steps.length * 350 + 300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      timers.forEach(clearTimeout);
      clearTimeout(finalTimer);
    };
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-6xl mx-auto" data-id="element-602">
      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: stage >= 1 ? 1 : 0,
      y: stage >= 1 ? 0 : 20
    }} data-id="element-603">
        <h2 className="text-4xl md:text-6xl font-sans font-bold text-white tracking-tight leading-tight" data-id="element-604">
          What Snakker does
        </h2>
        <motion.div initial={{
        width: 0
      }} animate={{
        width: stage >= 1 ? 80 : 0
      }} transition={{
        duration: 0.5
      }} className="h-[3px] bg-blue-400 rounded-full mt-3" data-id="element-605" />
      </motion.div>

      {/* Subhead */}
      <motion.p initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: stage >= 2 ? 1 : 0,
      y: stage >= 2 ? 0 : 10
    }} transition={{
      duration: 0.5
    }} className="text-xl md:text-2xl text-white/65 leading-relaxed max-w-3xl mt-10" data-id="element-606">
        Snakker acts as the{' '}
        <span className="text-white font-semibold" data-id="element-607">operating layer</span>{' '}
        between strategy and execution.
      </motion.p>

      {/* Steps */}
      <div className="flex-1 flex flex-col justify-center mt-10 space-y-4" data-id="element-608">
        {steps.map((step, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: stage >= 3 + idx ? 1 : 0,
        x: stage >= 3 + idx ? 0 : -20
      }} transition={{
        duration: 0.5
      }} className="flex items-center gap-5" data-id="element-609">
            <div className="w-12 h-12 rounded-xl bg-navy-800/60 border border-navy-600 flex items-center justify-center text-blue-400 flex-shrink-0" data-id="element-610">
              {step.icon}
            </div>
            <span className="text-lg md:text-xl text-white/85 leading-snug" data-id="element-611">
              {step.label}
            </span>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 3 + steps.length ? 1 : 0
    }} className="mt-8 flex justify-end" data-id="element-612">
        <Button onClick={onContinue} data-id="element-613">Snakker Platform</Button>
      </motion.div>
    </div>;
}